import React from "react";
import { Container, Row, Col } from "reactstrap";

const ACCENT = "#C66067";
const ACCENT_MID = "#70AEB8";
const MUTED = "rgba(255, 255, 255, 0.72)";
const SUBTLE = "rgba(255, 255, 255, 0.55)";

function SpeakerModal({ speaker }) {
  if (!speaker || (!speaker.name && !speaker.image)) {
    return null;
  }

  const size =
    typeof document !== "undefined" &&
    (document.body.clientWidth >= 768 || document.documentElement.clientWidth >= 768);

  const headline = speaker.sTitle || speaker.highlightText || "";

  return (
    <div
      className="speaker-modal-root"
      style={{
        background: "linear-gradient(165deg, #141414 0%, #0a0a0a 45%, #0d0d0d 100%)",
        color: "#fff",
        borderRadius: "12px",
        overflow: "hidden",
        position: "relative",
      }}
    >
      <div
        aria-hidden
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          width: `${minSize(140, 100)}px`,
          height: `${minSize(140, 100)}px`,
          background: `linear-gradient(135deg, rgba(198, 96, 103, 0.12) 0%, transparent 55%)`,
          pointerEvents: "none",
        }}
      />

      <Container fluid className="px-3 px-md-4 py-4 position-relative" style={{ zIndex: 1 }}>
        <Row className="align-items-start no-gutters">
          {speaker.image ? (
            <Col xs="auto" className="pr-3 pr-md-4 mb-3 mb-md-0">
              <div
                style={{
                  width: size ? 120 : 96,
                  height: size ? 120 : 96,
                  borderRadius: "50%",
                  padding: 3,
                  background: `linear-gradient(135deg, ${ACCENT} 0%, ${ACCENT_MID} 100%)`,
                  boxShadow: "0 12px 40px rgba(0, 0, 0, 0.45)",
                }}
              >
                <img
                  alt={speaker.name || "Speaker"}
                  src={speaker.image}
                  style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: "50%",
                    objectFit: "cover",
                    display: "block",
                    border: "2px solid #0a0a0a",
                  }}
                />
              </div>
            </Col>
          ) : null}

          <Col style={{ minWidth: 0 }}>
            {headline ? (
              <span
                className="d-inline-block mb-2"
                style={{
                  fontSize: "0.7rem",
                  fontWeight: 700,
                  letterSpacing: "0.12em",
                  color: ACCENT,
                  textTransform: "uppercase",
                }}
              >
                {headline}
              </span>
            ) : null}

            <h2
              className="mb-2"
              style={{
                fontSize: size ? "1.65rem" : "1.35rem",
                fontWeight: 700,
                lineHeight: 1.2,
                letterSpacing: "-0.02em",
                color: "#fff",
              }}
            >
              {speaker.name}
            </h2>

            {speaker.title ? (
              <div
                className="mb-2 speaker-modal-title"
                style={{
                  fontSize: size ? "1rem" : "0.92rem",
                  lineHeight: 1.5,
                  color: MUTED,
                  fontWeight: 500,
                }}
                dangerouslySetInnerHTML={{ __html: speaker.title }}
              />
            ) : null}

            {speaker.company ? (
              <p
                className="mb-0 text-i"
                style={{
                  fontSize: size ? "0.9rem" : "0.85rem",
                  color: SUBTLE,
                  lineHeight: 1.45,
                }}
              >
                {speaker.company}
              </p>
            ) : null}
          </Col>
        </Row>

        {speaker.bio ? (
          <>
            <div
              style={{
                height: 2,
                marginTop: "1.35rem",
                marginBottom: "1.15rem",
                borderRadius: 1,
                background: `linear-gradient(90deg, ${ACCENT}, ${ACCENT_MID}, transparent)`,
                maxWidth: 200,
              }}
            />
            <div
              className="speaker-modal-bio"
              style={{
                fontSize: size ? "0.95rem" : "0.88rem",
                lineHeight: 1.65,
                color: MUTED,
                maxHeight: `${minSize(320, 220)}px`,
                overflowY: "auto",
                paddingRight: 4,
              }}
              dangerouslySetInnerHTML={{ __html: speaker.bio }}
            />
          </>
        ) : null}
      </Container>

      <style>{`
        .speaker-modal-title p,
        .speaker-modal-title span { margin-bottom: 0.25rem; color: inherit !important; }
        .speaker-modal-title p:last-child { margin-bottom: 0; }
        .speaker-modal-bio p { margin-bottom: 0.65rem; color: ${MUTED} !important; }
        .speaker-modal-bio p:last-child { margin-bottom: 0; }
        .speaker-modal-bio span { color: inherit !important; }
        .speaker-modal-bio a { color: ${ACCENT} !important; text-decoration: none; border-bottom: 1px solid rgba(198, 96, 103, 0.35); }
        .speaker-modal-bio a:hover { color: ${ACCENT_MID} !important; border-bottom-color: ${ACCENT_MID}; }
        .speaker-modal-bio::-webkit-scrollbar { width: 6px; }
        .speaker-modal-bio::-webkit-scrollbar-track { background: rgba(255,255,255,0.04); border-radius: 3px; }
        .speaker-modal-bio::-webkit-scrollbar-thumb { background: rgba(198, 96, 103, 0.35); border-radius: 3px; }
      `}</style>
    </div>
  );
}

function minSize(a, b) {
  if (typeof document === "undefined") return a;
  const w = document.body.clientWidth || document.documentElement.clientWidth;
  return w >= 768 ? a : b;
}

export default SpeakerModal;
